<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title"><span style="white-space: nowrap">{{ $t('words.channel_manage')}}</span>
                        <span class="page-header-breadcrumb">></span>
                        <router-link :to="{ name: 'cms-channels-view', params: { channel_id: channel.id } }" class="broadcast__title text-link" v-tooltip="{ content: channel.title, html:false }">{{ channel.title }}</router-link>
                        <span class="page-header-breadcrumb">></span>
                        <span class="broadcast__title" v-tooltip="{ content: broadcast.title, html:false }">{{ broadcast.title }}</span><span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.statistics.channel_download_tip') }"><i class="icon icon-info-circle-line"></i></span></h3>
                    <div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
            </div>

            <div class="module" v-if="loadSummary">
                <div class="module-header" v-if="selectedBroadcast">
                    <h4 class="module-title"><span class="text-label">{{ $t('words.creator') }}</span>{{ broadcast.live_creator.nickname }} ({{ broadcast.live_creator.code }})</h4>
                    <div class="module-header-action">
                        <div class="text-help"><i class="icon icon-time mr-2"></i>{{ renderDatetime(broadcast.started_at) }}<span class="time__divider">~</span>{{ renderDatetime(broadcast.paused_at) }}</div>
                    </div>
                </div>
                <div class="module-body">
                    <ul class="dashboard">
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.max_acc_user') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.sum_user }}</p>
                        </li>
                        <li class="dashboard-item">
                        <h5 class="dashboard-title">{{ $t('words.total_acc_user') }}</h5>
                        <p class="dashboard-desc">{{ summaryData.total_acc_user }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.max_cur_user') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.max_cur_user }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.total_visit_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.total_count }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time" v-if="selectedBroadcast">
                            <h5 class="dashboard-title">{{ $t('words.total_broadcast_interval') }}</h5>
                            <p class="dashboard-desc">{{ broadcast.interval }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                            <h5 class="dashboard-title">{{ $t('words.total_watch_time') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.total_watch_time }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                        <h5 class="dashboard-title">{{ $t('words.average_watch_time') }}</h5>
                        <p class="dashboard-desc">{{ summaryData.average_watch_time }}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.watch_user') }}/{{ $t('words.visit_count') }}</h5>
                    <div class="module-header-action">
                        <select style="width:80px" id="request_interval" v-model="requestInterval">
                           <option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': requestData.loading}">
                    <request-chart ref="requestChart" :chartData="requestData" :interval="requestInterval" :created="requestData.created"></request-chart>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.traffic') }}/{{ $t('words.transfer') }}</h5>
                    <div class="module-header-action">
                        <select style="width:80px" id="transfer_interval" v-model="transferInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': transferData.loading}">
                    <transfer-chart ref="transferChart" :chartData="transferData" :interval="transferInterval" :created="transferData.created"></transfer-chart>
                </div>
            </div>

            <div class="module" v-show="!webrtcChannel">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.response_code') }}</h5>
                    <div class="module-header-action">
                        <select style="width:80px" id="response_interval" v-model="responseInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': responseData.loading}">
                    <response-chart ref="responseChart" :chartData="responseData" :interval="responseInterval" :created="responseData.created"></response-chart>
                </div>
            </div>

            <div class="module" v-show="!webrtcChannel">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.profile') }}</h5>
                    <div class="module-header-action">
                        <select style="width:80px" id="profile_interval" v-model="profileInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': profileData.loading}">
                    <profile-chart ref="profileChart" :chartData="profileData" :interval="profileInterval" :created="profileData.created"></profile-chart>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import ChannelStatusMixin from '../../mixin/ChannelStatusMixin';
import DateTimeMixin from '../../mixin/DateTimeMixin';
import ChannelConfig from './ChannelConfig';
import RequestChart from '../chart/RequestChart';
import TransferChart from '../chart/TransferChart';
import ResponseChart from '../chart/ResponseChart';
import ProfileChart from '../chart/ProfileChart';
import 'selectize';

export default {
    mixins: [
        GlobalConfigMixin,
        ChannelStatusMixin,
        DateTimeMixin,
    ],
    components: {
        RequestChart,
        TransferChart,
        ResponseChart,
        ProfileChart,
    },
    props: {
        channel_id: {
            type: [String, Number],
            require: true,
        },
        broadcast_id: {
            type: [String, Number],
            require: true,
        },
    },
    data() {
        return {
            intervals: ['5m', '10m', '1h', '1d'],
            selectedChannel: this.channel_id,
            // selectize_channels: null,
            // selectize_broadcasts: null,
            selectedBroadcast: this.broadcast_id,
            channel: {},
            broadcast: {},
            startDayLimit: '',
            endDayLimit: '',
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            requestInterval: '5m',
            requestData: {
                loading: false,
                labels: null,
                results: {
                    count: {},
                    accUser: {},
                    curUser: {},
                },
                created: null,
            },
            transferInterval: '5m',
            transferData: {
                loading: false,
                labels: null,
                results: {
                    traffic: {},
                    transfer: {},
                },
                created: null,
            },
            responseInterval: '5m',
            responseData: {
                loading: false,
                labels: null,
                results: {

                },
                created: null,
            },
            profileInterval: '5m',
            profileData: {
                loading: false,
                labels: null,
                legends: null,
                results: {

                },
                created: null,
            },
            summaryData: {
                total_count: 0,
                total_watch_time: '0',
                total_acc_user: 0,
                max_cur_user: 0,
                max_acc_user: 0,
                average_watch_time: '0',
                sum_user: 0,
            },
            loadSummary: false,
            // end random chart
        };
    },
    mounted() {
        const self = this;
        $('#request_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.requestInterval = value;
            },
        });
        $('#transfer_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.transferInterval = value;
            },
        });
        $('#response_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.responseInterval = value;
            },
        });
        $('#profile_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.profileInterval = value;
            },
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            // set reload path
            this.global_reload_path = 'cms-channels-list';
            this.loadChannel();
            this.loadBroadcast();
        },
        loadChart() {
            this.initRequestChartData();
            this.getRequestChartData();
            this.initTransferChartData();
            this.getTransferChartData();
            this.initResponseChartData();
            this.getResponseChartData();
            this.initProfileChartData();
            this.getProfileChartData();
        },
        loadChannel() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
            });
        },
        loadBroadcast() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.broadcastApi).then((response) => {
                this.broadcast = response.data.data;

                // this.broadcast.repeat = null;
                // if (this.broadcast.is_onair) {
                //     this.calBroadcastDuration(this.broadcast);
                // }

                const startedAt = this.$moment.utc(this.broadcast.started_at).add(-10, 'minutes'); // sub 10 minutes
                const endedAt = this.$moment.utc(this.broadcast.ended_at).add(10, 'minutes'); // add 10 minutes
                // let startHour = '00';
                // let endHour = '00';
                //
                // if (startedAt.format('mm') % 5 > 0) {
                //     startHour = `0${(Math.floor(startedAt.format('m') / 5) * 5 + 5)}`;
                // } else {
                //     startHour = `0${(Math.floor(startedAt.format('m') / 5) * 5)}`;
                // }
                // if (endedAt.format('mm') % 5 > 0) {
                //     endHour = `0${(Math.floor(endedAt.format('m') / 5) * 5 + 5)}`;
                // } else {
                //     endHour = `0${(Math.floor(endedAt.format('m') / 5) * 5)}`;
                // }
                //
                // this.startDay = `${startedAt.format('YYYY-MM-DD HH:')}${startHour.substring(startHour.length, startHour.length - 2)}:00`;
                // this.endDay = `${endedAt.format('YYYY-MM-DD HH:')}${endHour.substring(endHour.length, endHour.length - 2)}:00`;
                this.startDate = startedAt.format('YYYY-MM-DD HH:mm:ss');
                this.endDate = endedAt.format('YYYY-MM-DD HH:mm:ss');
                this.loadChart();

                this.loadSummary = true;
            });
        },
        // getDuration(started) {
        //     const startedUtc = this.$moment.utc(started);
        //     const nowDate = this.$moment().utc();
        //     let diff;
        //     diff = nowDate.format('X') - startedUtc.format('X');
        //     const days = Math.floor(diff / (24 * 60 * 60));
        //     if (days > 0) {
        //         diff %= (24 * 60 * 60);
        //     }
        //     const hours = Math.floor(diff / (60 * 60));
        //     const hoursStr = (hours < 10) ? `0${hours}` : hours;
        //     if (hours > 0) {
        //         diff %= (60 * 60);
        //     }
        //     const minutes = Math.floor(diff / 60);
        //     const minutesStr = (minutes < 10) ? `0${minutes}` : minutes;
        //     if (minutes > 0) {
        //         diff %= (60);
        //     }
        //     const seconds = diff;
        //     const secondsStr = (seconds < 10) ? `0${seconds}` : seconds;
        //     if (days > 0) {
        //         return `${days}d ${hoursStr}:${minutesStr}:${secondsStr}`;
        //     }
        //     return `${hoursStr}:${minutesStr}:${secondsStr}`;
        // },
        // calBroadcastDuration(broadcast) {
        //     const broadcastIns = broadcast;
        //     broadcastIns.repeat = setInterval(() => {
        //         broadcastIns.interval = this.getDuration(broadcast.started_at);
        //
        //         if (!broadcastIns.is_onair) {
        //             clearInterval(broadcastIns.repeat);
        //         }
        //     }, 1000);
        // },
        loadSelectChannel() {
            const self = this;
            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                onChange(value) {
                    self.loadSummary = false;
                    self.selectedChannel = value;
                    self.loadChart();
                    // self.loadRecordFiles(self.recordingFilesApiUri);
                    self.selectize_broadcasts.clear();
                    self.selectize_broadcasts.clearOptions();
                    self.selectize_broadcasts.disable();
                    self.selectize_broadcasts.load((callback) => {
                        if (!value.length) {
                            callback([{ id: '', title: 'All Lives' }]);
                            return;
                        }
                        const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts`;
                        axios.get(broadcastUri).then((response) => {
                            self.selectize_broadcasts.enable();
                            response.data.data.unshift({ id: '', title: 'All Lives' });
                            callback(response.data.data);
                        }).catch((error) => {
                            // self.$toasted.error('Failed to load lives');
                            // console.log(error.response.data.errors);
                            callback([{ id: '', title: 'All Lives' }]);
                        });
                    });
                    // self.selectize_broadcasts.setValue('', true);
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: 'All Channels' });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load channels');
                        console.log(error.response.data.errors);
                        callback([{ id: '', title: 'All Channels' }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
            this.loadSelectBroadcast();
        },
        loadSelectBroadcast() {
            const self = this;
            const selectizeObj = $('#select_live').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                onChange(value) {
                    self.selectedBroadcast = value;
                    // self.loadRecordFiles(self.recordingFilesApiUri);
                    // if (!value.length) return;

                    self.loadBroadcast();
                    self.loadChart();
                },
            });

            this.selectize_broadcasts = selectizeObj[0].selectize;
            this.selectize_broadcasts.clearOptions();
            this.selectize_broadcasts.disable();
        },
        initTransferChartData() {
            this.transferData.loading = true;
            this.transferData.labels = [];
            this.transferData.results.transfer = [];
            this.transferData.results.traffic = [];
            // this.transferData.created = moment().utc().format('X');
            this.$refs.transferChart.initialize();
        },
        async getTransferChartData() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/transfer`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.transferInterval}`;

            await axios.get(apiLoc).then((response) => {
                this.transferData.labels = response.data.labels;
                this.transferData.results.transfer = response.data.transferData;
                this.transferData.results.traffic = response.data.trafficData;
                // this.transferData.created = moment().utc().format('X') + 5; // becuase initialize
                this.$refs.transferChart.initialize();
                this.transferData.loading = false;
            }).catch((error) => {
                this.transferData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initResponseChartData() {
            this.responseData.loading = true;
            this.responseData.labels = [];
            this.responseData.results.results_1xx = [];
            this.responseData.results.results_2xx = [];
            this.responseData.results.results_3xx = [];
            this.responseData.results.results_4xx = [];
            this.responseData.results.results_5xx = [];

            this.$refs.responseChart.initialize();
            // this.responseData.created = moment().utc().format('X');
        },
        async getResponseChartData() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/response`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.responseInterval}`;

            await axios.get(apiLoc).then((response) => {
                this.responseData.labels = response.data.labels;
                this.responseData.results.results_1xx = response.data.results_1xx;
                this.responseData.results.results_2xx = response.data.results_2xx;
                this.responseData.results.results_3xx = response.data.results_3xx;
                this.responseData.results.results_4xx = response.data.results_4xx;
                this.responseData.results.results_5xx = response.data.results_5xx;

                this.$refs.responseChart.initialize();
                this.responseData.loading = false;
                // this.responseData.created = moment().utc().format('X') + 5;
            }).catch((error) => {
                this.responseData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initRequestChartData() {
            this.requestData.loading = true;
            this.requestData.labels = [];
            this.requestData.results.count = [];
            this.requestData.results.accUser = [];
            this.requestData.results.curUser = [];
            // this.requestData.created = moment().utc().format('X');
            this.$refs.requestChart.initialize();

            this.summaryData.total_count = 0;
            this.summaryData.total_watch_time = '0';
            this.summaryData.total_acc_user = 0;
            this.summaryData.max_cur_user = 0;
            this.summaryData.max_acc_user = 0;
            this.summaryData.average_watch_time = '0';
            this.summaryData.sum_user = 0;
        },
        async getRequestChartData() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/request`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.requestInterval}`;

            const self = this;
            await axios.get(apiLoc).then((response) => {
                self.requestData.labels = response.data.labels;
                self.requestData.results.count = response.data.countData;
                self.requestData.results.accUser = response.data.accUserData;
                self.requestData.results.curUser = response.data.curUserData;
                // self.requestData.created = moment().utc().format('X') + 5;
                self.$refs.requestChart.initialize();
                self.requestData.loading = false;

                self.summaryData.total_count = response.data.summaryData.total_count;
                self.summaryData.total_watch_time = response.data.summaryData.total_watch_time;
                self.summaryData.average_watch_time = response.data.summaryData.average_watch_time;
                self.summaryData.total_acc_user = response.data.summaryData.total_acc_user;
                self.summaryData.max_cur_user = response.data.summaryData.max_cur_user;
                self.summaryData.max_acc_user = response.data.summaryData.max_acc_user;
                self.summaryData.sum_user = response.data.summaryData.sum_user;
            }).catch((error) => {
                self.requestData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initProfileChartData() {
            this.profileData.loading = true;
            this.profileData.labels = [];
            this.profileData.legends = [];
            this.profileData.results = [];

            this.$refs.profileChart.initialize();
            // this.responseData.created = moment().utc().format('X');
        },
        async getProfileChartData() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/profile`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.profileInterval}`;

            await axios.get(apiLoc).then((response) => {
                this.profileData.labels = response.data.labels;
                this.profileData.legends = response.data.legends;
                this.profileData.results = response.data.results;

                this.$refs.profileChart.initialize();
                this.profileData.loading = false;
                // this.responseData.created = moment().utc().format('X') + 5;
            }).catch((error) => {
                this.profileData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.selectedBroadcast}`;
        },
        getExportUrl() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/export_channel`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }

            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.requestInterval}`;

            return apiLoc;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        transferInterval(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.initTransferChartData();
                this.getTransferChartData();
            }
        },
        responseInterval(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.initResponseChartData();
                this.getResponseChartData();
            }
        },
        requestInterval(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.initRequestChartData();
                this.getRequestChartData();
            }
        },
        profileInterval(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.initProfileChartData();
                this.getProfileChartData();
            }
        },
    },
};
</script>
